import React, { Fragment, useEffect, useRef, useCallback } from "react";
import { useState } from "react";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import type { NextPage } from "next";
import Image from "next/image";
import Layout from "../layout/layout";
import CameraPermission from "../components/shap-of-you/CameraPermission";
import CameraAccessDenied from "../components/shap-of-you/CameraAccessDenied";
import FaceScan from "../components/shap-of-you/FaceScan";
import Product from "../components/shap-of-you/Product";
import Signup from "../components/shap-of-you/Signup";
import shapemainbanner from "../assets/images/Shape-of you-main.jpeg";
import shapemainbannerpost from "../assets/images/Shape-of you-main-1.jpeg";
import Shapeofyoupost from "../assets/images/Shape-of-you-post_2.jpg";
import shapelogo from "../assets/images/shape-logo.png";
import logoabout from "../assets/images/logoabout.png";
import shapofyoulogo from "../assets/images/SENCO-SHAPE-OF-YOU-FULL_2.gif";
import { authActions, selectAuth } from "@/store/slices/auth";
import { selectShapeOfYou } from "@/store/slices/shapeOfYou";
import { useRouter } from "next/router";
import img1 from "../assets/images/WalkthroughScreen.png";
import img2 from "../assets/images/WalkthroughScreen2n.png";
import sencoLogo from "../assets/images/senco-shap-scree.png";
import shapesenco from "../assets/images/shapesenco.png";
import WelcomeScreenImg from "../assets/images/WelcomeScreen_dek.png";
import cemeraNeeded from "../assets/images/windown.png";
import SOYLockUp from "../assets/images/spl.png";
import FaceUpload from "../assets/images/Face_Upload_Info.png";
import decktoFace from "../assets/images/decktoFace.png";
import SharePage from "../assets/images/SharePage.png";
import logoleft from "../assets/images/logo-left.png";
import styles from "../styles/shap_of_you.module.scss";

// External function to check camera permission
const checkCameraPermission = async (): Promise<boolean> => {
  if (typeof window === "undefined") {
    return false;
  }

  try {
    // Then check browser's actual permission state
    const status = await navigator.permissions.query({
      name: "camera" as PermissionName,
    });
    return status.state === "granted";
  } catch (error) {
    console.error("Error checking camera permission:", error);
    return false;
  }
};
import { useSelector } from "react-redux";
import SwiperCore, { Autoplay, Navigation, Pagination } from "swiper";
import { Swiper, SwiperSlide } from "swiper/react";
import httpClient from "@/api/http-client";
import endpoints from "@/api/endpoints";

// UUID v4 generator
const generateUUID = () => {
  return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, function (c) {
    const r = (Math.random() * 16) | 0;
    const v = c === "x" ? r : (r & 0x3) | 0x8;
    return v?.toString(16);
  });
};
import {
  SplashScreen,
  WalkthroughScreen,
  AboutScreen,
  TermsConditionsScreen,
  WelcomeScreen,
  UploadOrScanScreen,
  PermissionDeniedScreen,
  GalleryPermissionScreen,
  FaceResultScreen,
  CameraPermissionScreen,
  FaceScanningScreen,
  LoginScreen,
  SignupScreen,
  VerifyOtpScreen,
  FilterViewScreen,
  ProductViewScreen,
  ShareViewScreen,
  PhotoCaptureFlow,
  AuthenticationFlow,
} from "../components/shape-of-you-mobile";
import type {
  MobileStep,
  PhotoCaptureStep,
  AuthStep,
  FilterState,
} from "../components/shape-of-you-mobile";

// Desktop components
import {
  SplashScreen as DesktopSplashScreen,
  WalkthroughScreen as DesktopWalkthroughScreen,
  AboutScreen as DesktopAboutScreen,
  TermsConditionsScreen as DesktopTermsConditionsScreen,
  WelcomeScreen as DesktopWelcomeScreen,
  UploadOrScanScreen as DesktopUploadOrScanScreen,
  GalleryPermissionScreen as DesktopGalleryPermissionScreen,
  CameraPermissionScreen as DesktopCameraPermissionScreen,
  PermissionDeniedScreen as DesktopPermissionDeniedScreen,
  FaceResultScreen as DesktopFaceResultScreen,
  FaceScanningScreen as DesktopFaceScanningScreen,
  LoginScreen as DesktopLoginScreen,
  SignupScreen as DesktopSignupScreen,
  VerifyOtpScreen as DesktopVerifyOtpScreen,
  ProductViewScreen as DesktopProductViewScreen,
  FilterViewScreen as DesktopFilterViewScreen,
  ShareViewScreen as DesktopShareViewScreen,
  PhotoCaptureFlow as DesktopPhotoCaptureFlow,
  AuthenticationFlow as DesktopAuthenticationFlow,
} from "../components/shape-of-you-desktop-new";
import type {
  DesktopStep,
  PhotoCaptureStep as DesktopPhotoCaptureStep,
  AuthStep as DesktopAuthStep,
} from "../components/shape-of-you-desktop-new";
const ShapOfYou: NextPage = () => {
  const [showModal, setShowModal] = useState(false);
  const [modalStep, setModalStep] = useState<
    | "introSlider"
    | "introExperience"
    | "camera"
    | "cameraAccessDenied"
    | "faceScan"
    | "product"
    | "signup"
  >("introSlider");
  const router = useRouter();
  const [activeTab, setActiveTab] = useState("Necklace");
  const [selected, setSelected] = useState<number | string>(1);
  const [activeFilterTab, setActiveFilterTab] = useState("Purity");
  const [selectedPurity, setSelectedPurity] = useState("24K Yellow Gold");
  const [showFilter, setShowFilter] = useState(false);
  const [selectedPriceRange, setSelectedPriceRange] = useState("₹0 – ₹10,000");
  const [selectedOccassion, setSelectedOccassion] = useState("Anniversary");
  const authState = useSelector(selectAuth);
  const shapeOfYouState = useSelector(selectShapeOfYou);

  // Filter state for mobile view
  const [mobileFilter, setMobileFilter] = useState<FilterState>({
    metal: [],
    occasions: [],
    priceRange: null,
    priceMin: null,
    priceMax: null,
  });

  // Check camera permission on component mount
  const initializeCameraPermission = async () => {
    const hasPermission = await checkCameraPermission();
    console.log("Camera permission status:", hasPermission);

    // If permission is already granted, skip camera modal and go to faceScan
    if (hasPermission) {
      setModalStep("faceScan");
    } else {
      setModalStep("camera");
    }
  };
  useEffect(() => {
    initializeCameraPermission();
  }, []);

  const handleCloseModal = () => {
    initializeCameraPermission();
    setShowModal(false);
  };

  const handleStartExperience = () => {
    setShowModal(true);
    setModalStep("introSlider");
  };

  const handleIntroSliderGetStarted = () => {
    setModalStep("introExperience");
  };

  const handleIntroExperienceGetStarted = () => {
    initializeCameraPermission();
  };

  // Auto-navigate to product if user is already logged in when signup step is reached
  useEffect(() => {
    if (modalStep === "signup" && authState.user) {
      setModalStep("product");
    }
  }, [modalStep, authState.user, setModalStep]);
  const [loading, setLoading] = useState(false);

  const handleScan = () => {
    setLoading(true);

    // Fake scanning
    setTimeout(() => {
      setLoading(false);
      alert("Scan Complete!");
    }, 4000);
  };
  // const [selectedTab, setSelectedTab] = useState("price");
  // const [selectedPrice, setSelectedPrice] = useState("₹0 – ₹10,000");
  // const [selectedImage, setSelectedImage] = useState("necklace");
  // const [activeCategory, setActiveCategory] = useState("Necklace");

  // Mobile flow state management
  const [mobileStep, setMobileStep] = useState<MobileStep>("splash");

  // Desktop flow state management
  const [desktopStep, setDesktopStep] = useState<DesktopStep>("splash");

  // Session ID for logging (generated once per session, regenerates on refresh)
  const [sessionId] = useState<string>(() => generateUUID());

  // Logging utility function for Shape of You mobile flow
  const logShapeOfYouStep = useCallback(
    async (
      step: string,
      apiDetails?: {
        api_endpoint?: string;
        request_payload?: any;
        response_status?: number;
        response_payload?: any;
        success_message?: string | null;
        success_code?: string | null;
        error_message?: string | null;
        error_code?: string | null;
      }
    ) => {
      try {
        const payload = {
          session_id: sessionId,
          user_mobile: authState.user?.mobile || null,
          step: step,
          api_endpoint: apiDetails?.api_endpoint || null,
          request_payload: apiDetails?.request_payload || null,
          response_status: apiDetails?.response_status ?? null,
          response_payload: apiDetails?.response_payload || null,
          success_message: apiDetails?.success_message || null,
          success_code: apiDetails?.success_code || null,
          error_message: apiDetails?.error_message || null,
          error_code: apiDetails?.error_code || null,
        };

        await httpClient.post(endpoints.shape_of_you.log(), payload);
        console.log("Shape of You log sent:", step, payload);
      } catch (error) {
        console.error("Failed to log Shape of You step:", error);
      }
    },
    [sessionId, authState.user?.mobile]
  );

  // Generic navigation function for mobile steps
  const navigateToStep = (step: MobileStep) => {
    setMobileStep(step);
  };

  // Generic navigation function for desktop steps
  const navigateToDesktopStep = (step: DesktopStep) => {
    setDesktopStep(step);
  };

  // Auto-navigate from splash to walkthrough after 3 seconds (mobile)
  useEffect(() => {
    if (mobileStep === "splash") {
      const timer = setTimeout(() => {
        setMobileStep("walkthrough");
      }, 5000);
      return () => clearTimeout(timer);
    }
  }, [mobileStep]);

  // Auto-navigate from splash to walkthrough after 3 seconds (desktop)
  useEffect(() => {
    if (desktopStep === "splash") {
      const timer = setTimeout(() => {
        setDesktopStep("walkthrough");
      }, 5000);
      return () => clearTimeout(timer);
    }
  }, [desktopStep]);

  // Auto-navigate to productView if user is already logged in (mobile)
  useEffect(() => {
    if (
      authState.user &&
      (mobileStep === "login" ||
        mobileStep === "signup" ||
        mobileStep === "verifyOtp")
    ) {
      setMobileStep("productView");
    }
  }, [mobileStep, authState.user]);

  // Auto-navigate to productView if user is already logged in (desktop)
  useEffect(() => {
    if (
      authState.user &&
      (desktopStep === "login" ||
        desktopStep === "signup" ||
        desktopStep === "verifyOtp")
    ) {
      setDesktopStep("productView");
    }
  }, [desktopStep, authState.user]);

  // Handle pending navigation from PermissionDeniedScreen (Mobile)
  useEffect(() => {
    const pendingNav = localStorage.getItem("pendingNavigation");
    if (pendingNav && mobileStep === "splash") {
      // Clear the flag
      localStorage.removeItem("pendingNavigation");
      // Navigate to the pending destination
      setMobileStep(pendingNav as MobileStep);
    }
  }, [mobileStep]);

  // Handle pending navigation from PermissionDeniedScreen (Desktop)
  useEffect(() => {
    const pendingNav = localStorage.getItem("pendingNavigation");
    if (pendingNav && desktopStep === "splash") {
      // Clear the flag
      localStorage.removeItem("pendingNavigation");
      // Navigate to the pending destination
      setDesktopStep(pendingNav as DesktopStep);
    }
  }, [desktopStep]);

  // Log mobile step changes
  useEffect(() => {
    // Map mobileStep to log step names
    const stepMapping: Partial<Record<MobileStep, string>> = {
      splash: "intro_slider_viewed",
      walkthrough: "intro_slider_viewed",
      about: "intro_slider_viewed",
      welcome: "intro_experience_started",
      uploadOrScan: "face_scan_captured",
      faceResult: "face_scan_proceeded",
      login: "signup_viewed",
      signup: "signup_viewed",
      productView: "product_viewed",
    };

    const logStep = stepMapping[mobileStep];
    if (logStep) {
      logShapeOfYouStep(logStep);
    }
  }, [mobileStep, logShapeOfYouStep]);

  // Log desktop step changes
  useEffect(() => {
    // Map desktopStep to log step names
    const stepMapping: Partial<Record<DesktopStep, string>> = {
      splash: "intro_slider_viewed",
      walkthrough: "intro_slider_viewed",
      about: "intro_slider_viewed",
      welcome: "intro_experience_started",
      uploadOrScan: "face_scan_captured",
      faceResult: "face_scan_proceeded",
      login: "signup_viewed",
      signup: "signup_viewed",
      productView: "product_viewed",
    };

    const logStep = stepMapping[desktopStep];
    if (logStep) {
      logShapeOfYouStep(logStep);
    }
  }, [desktopStep, logShapeOfYouStep]);

  // Track session abandonment
  const hasReachedProductView = useRef(false);
  const sessionCompleted = useRef(false);

  // Mark when user reaches product view (engaged with the experience) - Mobile
  useEffect(() => {
    if (mobileStep === "productView") {
      hasReachedProductView.current = true;
    }
  }, [mobileStep]);

  // Mark when user reaches product view (engaged with the experience) - Desktop
  useEffect(() => {
    if (desktopStep === "productView") {
      hasReachedProductView.current = true;
    }
  }, [desktopStep]);

  // Mark session as completed when user reaches shareView (Mobile)
  useEffect(() => {
    if (mobileStep === "shareView" && !sessionCompleted.current) {
      sessionCompleted.current = true;
      logShapeOfYouStep("session_completed", {
        success_message: "User completed the Shape of You experience",
        success_code: "SESSION_COMPLETE",
        response_payload: {
          completion_type: "share_view_reached",
          completed_at: new Date().toISOString(),
        },
      });
    }
  }, [mobileStep, logShapeOfYouStep]);

  // Mark session as completed when user reaches shareView (Desktop)
  useEffect(() => {
    if (desktopStep === "shareView" && !sessionCompleted.current) {
      sessionCompleted.current = true;
      logShapeOfYouStep("session_completed", {
        success_message: "User completed the Shape of You experience",
        success_code: "SESSION_COMPLETE",
        response_payload: {
          completion_type: "share_view_reached",
          completed_at: new Date().toISOString(),
        },
      });
    }
  }, [desktopStep, logShapeOfYouStep]);

  // Track if user abandons session by navigating away from product view back to early steps (Mobile)
  useEffect(() => {
    // If user reached product view but then goes back to splash/walkthrough/welcome (abandoning the flow)
    if (
      hasReachedProductView.current &&
      !sessionCompleted.current &&
      (mobileStep === "splash" ||
        mobileStep === "walkthrough" ||
        mobileStep === "welcome")
    ) {
      logShapeOfYouStep("session_abandoned", {
        error_message: "User navigated away from product view",
        error_code: "NAVIGATION_BACK",
        request_payload: {
          abandonment_trigger: "navigation",
          from_step: "productView",
          to_step: mobileStep,
        },
        response_payload: {
          abandonment_type: "navigation_back",
          last_step: "productView",
          navigated_to: mobileStep,
          abandoned_at: new Date().toISOString(),
          user_reached_product_view: true,
        },
      });
      sessionCompleted.current = true; // Mark as handled
    }
  }, [mobileStep, logShapeOfYouStep]);

  // Track if user abandons session by navigating away from product view back to early steps (Desktop)
  useEffect(() => {
    // If user reached product view but then goes back to splash/walkthrough/welcome (abandoning the flow)
    if (
      hasReachedProductView.current &&
      !sessionCompleted.current &&
      (desktopStep === "splash" ||
        desktopStep === "walkthrough" ||
        desktopStep === "welcome")
    ) {
      logShapeOfYouStep("session_abandoned", {
        error_message: "User navigated away from product view",
        error_code: "NAVIGATION_BACK",
        request_payload: {
          abandonment_trigger: "navigation",
          from_step: "productView",
          to_step: desktopStep,
        },
        response_payload: {
          abandonment_type: "navigation_back",
          last_step: "productView",
          navigated_to: desktopStep,
          abandoned_at: new Date().toISOString(),
          user_reached_product_view: true,
        },
      });
      sessionCompleted.current = true; // Mark as handled
    }
  }, [desktopStep, logShapeOfYouStep]);

  // Track session abandonment on page unload (user closes tab/browser or refreshes)
  useEffect(() => {
    const handleBeforeUnload = (e: BeforeUnloadEvent) => {
      // Only log abandonment if user reached product view but didn't complete session
      if (hasReachedProductView.current && !sessionCompleted.current) {
        // Determine which view is active (use desktopStep if user is on desktop, mobileStep otherwise)
        const currentStep = window.innerWidth >= 768 ? desktopStep : mobileStep;

        // Use sendBeacon for reliable logging on page unload
        const payload = {
          session_id: sessionId,
          user_mobile: authState.user?.mobile || null,
          step: "session_abandoned",
          api_endpoint: null,
          request_payload: {
            abandonment_trigger: "page_unload",
            from_step: currentStep,
            user_authenticated: !!authState.user,
            view_type: window.innerWidth >= 768 ? "desktop" : "mobile",
          },
          response_status: null,
          response_payload: {
            abandonment_type: "page_unload",
            last_step: currentStep,
            abandoned_at: new Date().toISOString(),
            user_reached_product_view: true,
            user_mobile: authState.user?.mobile || null,
          },
          success_message: null,
          success_code: null,
          error_message:
            "User closed page or refreshed without completing session",
          error_code: "PAGE_UNLOAD",
        };

        // Use sendBeacon for reliable delivery during page unload
        if (navigator.sendBeacon) {
          const blob = new Blob([JSON.stringify(payload)], {
            type: "application/json",
          });
          navigator.sendBeacon(endpoints.shape_of_you.log(), blob);
        }
      }
    };

    window.addEventListener("beforeunload", handleBeforeUnload);
    return () => {
      window.removeEventListener("beforeunload", handleBeforeUnload);
    };
  }, [sessionId, authState.user, mobileStep, desktopStep]);
  const [show, setShow] = useState(false);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  return (
    <>
      {/* ========== OLD DESKTOP VIEWS - COMMENTED OUT ========== */}
      {false && (
        <>
          {/* splash screen */}
          {/* mobileStep === "splash" */}
          <div className="d-none  w-100">
            <div className={styles.desktop_view_shap}>
              <div className={styles.shapeOfYou}>
                <div className={styles.content}>
                  <div className={styles.title}>
                    <Image src={shapofyoulogo} alt="Shape of You Logo" />
                  </div>
                  <div className={styles.byLine}>
                    <Image
                      src={sencoLogo}
                      alt="Senco Gold & Diamonds"
                      className={styles.logo}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
          {/* WalkthroughScreen */}
          {/* mobileStep === "walkthrough" */}
          <div className="d-none w-100">
            <div className={styles.wrapper_slider_desktop}>
              <Swiper
                spaceBetween={30}
                pagination={{
                  clickable: true,
                }}
                modules={[Pagination]}
                className="mySwiper"
              >
                <SwiperSlide>
                  <div className={styles.swiperSlide}>
                    <div className={styles.slide}>
                      <Image
                        className={styles.bgImage}
                        src={img1}
                        alt="Scan Your Face"
                      />

                      <div className={styles.overlay_n}>
                        <h2>Scan Your Face</h2>
                        <p>Upload or take a photo of your face</p>
                      </div>
                    </div>
                  </div>
                </SwiperSlide>
                <SwiperSlide>
                  <div className={styles.swiperSlide}>
                    <div className={styles.slide}>
                      <Image
                        className={styles.bgImage}
                        src={img2}
                        alt="Live Analysis"
                      />

                      <div className={styles.overlay_n}>
                        <h2>Live Analysis</h2>
                        <p>Get instant analysis of your face type</p>
                      </div>
                    </div>
                  </div>
                </SwiperSlide>
                <SwiperSlide>
                  <div className={styles.swiperSlide}>
                    <div className={styles.banner1}>
                      <Image className={styles.bgImage} src={img1} alt="" />
                      <div className={styles.overlay_n}>
                        <h2>The Shape of You</h2>
                        <p>
                          Discover your face shape and shop jewellery made for
                          you.
                        </p>
                        <div className={styles.buttonGroup}>
                          <button
                            className={styles.secondaryBtn}
                            onClick={() => navigateToStep("about")}
                          >
                            Know More
                          </button>
                          <div>OR</div>
                          <button
                            className={styles.primaryBtn}
                            style={
                              loading
                                ? {
                                    background: "#d3d3d3",
                                    color: "#888",
                                    cursor: "not-allowed",
                                    opacity: 0.6,
                                  }
                                : {}
                            }
                          >
                            {loading ? "Loading..." : "Get Started"}{" "}
                            <svg
                              width="25"
                              height="17"
                              viewBox="0 0 30 20"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                d="M0.000209928 11.0458L0 8.04596H24.2579L18.3333 2.12131L20.4546 0L30.0006 9.54596L20.4546 19.092L18.3333 16.9705L24.258 11.046L0.000209928 11.0458Z"
                                fill="white"
                              />
                            </svg>
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </SwiperSlide>
              </Swiper>
            </div>
          </div>
          {/* About Screen */}
          {/* mobileStep === "about" */}
          <div className="d-none w-100">
            <section className={styles.experienceSectionDesktop}>
              <div className="w-100">
                {/* Brand Logo */}
                <div className={styles.brandLogo}>
                  <Image src={logoabout} alt="Shape of You Logo" />
                </div>

                <div className={styles.experienceCard}>
                  <div className={styles.experienceContent}>
                    <div className="row">
                      <div className="col-md-7">
                        {/* Video */}
                        <div className={styles.videoContainer}>
                          <iframe
                            width="100%"
                            height="400"
                            src="https://www.youtube.com/embed/qm7VBAvx7U0"
                            title="Kiara Advani In Vivaha Collection '22 By Senco Gold & Diamonds"
                            frameBorder="0"
                            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                            referrerPolicy="strict-origin-when-cross-origin"
                            allowFullScreen
                          ></iframe>
                        </div>
                      </div>
                      <div className="col-md-5">
                        {/* Text */}
                        <div className={styles.textContent}>
                          <h2>Jewellery That Matches Your Face Shape</h2>

                          <p>
                            Every face tells its own story, and the jewellery
                            you wear should reflect that individuality.
                            Understanding the shape of your face is the key to
                            selecting pieces that not only complement your
                            natural features but elevate them with effortless
                            elegance. With Shape of You, Senco’s innovative
                            expert styling approach, you can now discover
                            jewellery designs tailored to your unique contours
                            and personality. From earrings that refine angles to
                            necklaces that balance proportions, each
                            recommendation is chosen with intention. Because the
                            perfect jewellery does more than accessorise - it
                            highlights confidence, enhances beauty, and above
                            all, celebrates you.
                          </p>
                          <button className={styles.ctaButton}>
                            Start Experience{" "}
                            <span>
                              <svg
                                width="25"
                                height="17"
                                viewBox="0 0 30 20"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <path
                                  d="M0.000209928 11.0458L0 8.04596H24.2579L18.3333 2.12131L20.4546 0L30.0006 9.54596L20.4546 19.092L18.3333 16.9705L24.258 11.046L0.000209928 11.0458Z"
                                  fill="white"
                                />
                              </svg>
                            </span>
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </section>
          </div>
          {/* TermsConditionsScreen */}
          {/* mobileStep === "tc" */}
          <div className="d-none w-100">
            <div className={styles.wrapper_tc_desktop}>
              {/* Header */}
              <div className={styles.wrapper_sec}>
                <header className={styles.header}>
                  <Image src={shapesenco} alt="Logo" />
                </header>

                {/* Content */}
                <div className={styles.content}>
                  <h2>Privacy Policy and T&C</h2>

                  <p>
                    Lorem ipsum dolor sit amet consectetur. Volutpat arcu
                    ridiculus egestas molestie consectetur faucibus. Sit
                    faucibus vitae odio vulputate feugiat dignissim a duis. Id
                    nec amet mauris egestas. Pulvinar eu augue adipiscing amet.
                    Faucibus aenean sed non donec quam lectus euismod
                    scelerisque sit. Parturient viverra eu enim donec dui dolor
                    enim. Tristique pharetra non urna aliquet sit dignissim
                    ornare lectus. Iaculis ullamcorper arcu tellus purus
                    pellentesque laoreet ut. Consectetur non pellentesque
                    iaculis posuere arcu. Aliquam rhoncus enim mattis est. Est
                    donec imperdiet elementum arcu tellus interdum elit. Cursus
                    luctus ac dignissim porta tellus. Maecenas integer sagittis
                    integer enim et aliquam diam a. Aliquam posuere in amet enim
                    et egestas diam viverra. Lorem sed id cum id. Consectetur
                    sollicitudin elementum feugiat elementum etiam. Viverra enim
                    arcu est convallis mi at. Adipiscing sed in amet ut blandit
                    facilisis pellentesque. Aliquam blandit elementum dictumst
                    quis quis tellus gravida. Gravida ut consectetur risus metus
                    maecenas auctor. Nisi libero sed pellentesque sagittis
                    semper ac id amet tortor. Non dictum sit purus erat bibendum
                    lectus felis lectus nisl. Magna sed laoreet sit risus
                    tristique ut. Leo nisl cras at cras tortor senectus neque
                    feugiat elit. Amet eget sollicitudin nibh diam. Laoreet
                    adipiscing faucibus amet eget aenean consequat diam eget. Eu
                    convallis in non pretium nunc a. Interdum ac non semper
                    etiam magna. Tristique sodales aliquet nec lectus ultrices
                    tincidunt id at. In lacus scelerisque scelerisque sodales.
                    Id ut arcu sed ornare. Quis consequat at dictumst elementum.
                    Fringilla egestas sit massa viverra. Mauris etiam tellus
                    neque morbi in proin. Nibh integer quisque tellus ut ut
                    lectus feugiat habitant consectetur. Non vel vestibulum
                    elementum bibendum euismod faucibus condimentum. Nulla lacus
                    lectus laoreet sit molestie a sit. Rhoncus mi lacus et
                    aenean id quisque eu justo. Phasellus ullamcorper vulputate
                    adipiscing id. Eleifend parturient risus nec lorem a
                    molestie in mauris. Pulvinar faucibus tempus sit enim. Sed
                    pellentesque arcu turpis etiam semper. Dui erat leo duis
                    leo. Venenatis sed dignissim tincidunt felis turpis cum
                    viverra egestas et. Ut quis convallis quis lectus mi aliquet
                    cursus. Est aliquam facilisis aenean at eget nunc orci. Dui
                    in in ullamcorper habitant. Ac nibh fermentum aliquam proin
                    laoreet arcu ut odio senectus. Id ut porttitor sed sed et
                    fringilla lectus. In ullamcorper quam scelerisque proin
                    semper aliquet ut. Aenean duis massa suspendisse at.
                    Faucibus venenatis morbi praesent vivamus ut nullam neque.
                    Vitae tempor justo sit dolor auctor sit placerat
                    ullamcorper. Lectus nunc adipiscing turpis risus urna dolor
                    nunc nibh. Sollicitudin maecenas tortor urna etiam accumsan
                    arcu diam gravida. Pretium mauris id mauris accumsan. Nibh
                    mauris congue malesuada volutpat malesuada. In quis et
                    volutpat ut orci faucibus.
                  </p>
                </div>
              </div>
              {/* CTA */}
              <div className={styles.cta_btn_container}>
                <div className={styles.btn_act}>
                  <button className={styles.ctaBtn1} disabled={loading}>
                    Don&apos;t Agree
                  </button>
                  <button
                    className={styles.ctaBtn}
                    disabled={loading}
                    style={
                      loading
                        ? {
                            background: "#d3d3d3",
                            color: "#888",
                            cursor: "not-allowed",
                            opacity: 0.6,
                          }
                        : {}
                    }
                  >
                    {loading ? "Processing..." : "Agree and Proceed"} →
                  </button>
                </div>
              </div>
            </div>
          </div>
          {/* WelcomeScreen */}
          {/* mobileStep === "welcome" */}
          <div className="d-none w-100">
            <div className={styles.desktop_view_shap_welcome}>
              <div className={styles.bgImage}>
                <Image src={WelcomeScreenImg} alt="Welcome Screen" />
              </div>
              <div className={styles.shapeOfYou}>
                <div className={styles.content}>
                  <div className={styles.title}>
                    <Image src={SOYLockUp} alt="Shape of You Logo" />
                  </div>
                </div>
                <div className={styles.button_cont}>
                  <button
                    className={styles.ctaBtn}
                    onClick={() => navigateToStep("uploadOrScan")}
                  >
                    Start Experience →
                  </button>
                </div>
              </div>
            </div>
          </div>
          {/* PhotoCaptureFlow */}
          {/* mobileStep === "uploadOrScan */}
          <div className="d-none w-100 ">
            <div
              className={`${
                styles.desktop_view_shap_welcome
              } ${"desktop_view_shap_welcome"}`}
            >
              <div className={styles.bgImage}>
                <Image src={WelcomeScreenImg} alt="Welcome Screen" />
              </div>
              <div className={styles.shapeOfYou}>
                <div className={styles.content}>
                  <div className={styles.title}>
                    <Image src={SOYLockUp} alt="Shape of You Logo" />
                  </div>
                </div>
                <div className={styles.button_cont}>
                  <button className={styles.ctaBtn}>
                    Upload your Images{" "}
                    <svg
                      className="ml-1"
                      width="20"
                      height="20"
                      viewBox="0 0 36 36"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M22.5 12H22.5146"
                        stroke="white"
                        strokeWidth="3"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                      <path
                        d="M18.75 31.5H9C7.80653 31.5 6.66193 31.0259 5.81802 30.182C4.97411 29.3381 4.5 28.1935 4.5 27V9C4.5 7.80653 4.97411 6.66193 5.81802 5.81802C6.66193 4.97411 7.80653 4.5 9 4.5H27C28.1935 4.5 29.3381 4.97411 30.182 5.81802C31.0259 6.66193 31.5 7.80653 31.5 9V18.75"
                        stroke="white"
                        strokeWidth="3"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                      <path
                        d="M4.5 24L12 16.5C13.392 15.1605 15.108 15.1605 16.5 16.5L21.75 21.75"
                        stroke="white"
                        strokeWidth="3"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                      <path
                        d="M21 21L22.5 19.5C23.5185 18.5205 24.7095 18.2565 25.821 18.711"
                        stroke="white"
                        strokeWidth="3"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                      <path
                        d="M28.5 33V24"
                        stroke="white"
                        strokeWidth="3"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                      <path
                        d="M33 28.5L28.5 24L24 28.5"
                        stroke="white"
                        strokeWidth="3"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                    </svg>
                  </button>
                  <div>OR</div>
                  <button className={styles.ctaBtn} onClick={handleShow}>
                    Scan Face{" "}
                    <svg
                      className="ml-1"
                      width="20"
                      height="20"
                      viewBox="0 0 36 36"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M10.5 4.5H7.5C5.84314 4.5 4.5 5.84314 4.5 7.5V10.5"
                        stroke="white"
                        strokeWidth="3"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                      <path
                        d="M25.5 4.5H28.5C30.1569 4.5 31.5 5.84314 31.5 7.5V10.5"
                        stroke="white"
                        strokeWidth="3"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                      <path
                        d="M22.5 13.5V16.5"
                        stroke="white"
                        strokeWidth="3"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                      <path
                        d="M13.5 13.5V16.5"
                        stroke="white"
                        strokeWidth="3"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                      <path
                        d="M13.5 22.5C13.5 22.5 15 24 18 24C21 24 22.5 22.5 22.5 22.5"
                        stroke="white"
                        strokeWidth="3"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                      <path
                        d="M10.5 31.5001H7.5C5.84314 31.5001 4.5 30.157 4.5 28.5001V25.5001"
                        stroke="white"
                        strokeWidth="3"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                      <path
                        d="M25.5 31.5001H28.5C30.1569 31.5001 31.5 30.157 31.5 28.5001V25.5001"
                        stroke="white"
                        strokeWidth="3"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                    </svg>
                  </button>
                </div>
              </div>
            </div>
            <Modal
              show={show}
              onHide={handleClose}
              className={styles.custom_modal}
              centered
            >
              <Modal.Body>
                <div className={styles.modal}>
                  <h3>
                    sencogoldanddiamonds.com <br /> wants to
                  </h3>

                  <label className={styles.checkbox}>
                    <svg
                      width="20"
                      height="16"
                      viewBox="0 0 30 24"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M3 24C2.175 24 1.46875 23.7063 0.88125 23.1188C0.29375 22.5312 0 21.825 0 21V3C0 2.175 0.29375 1.46875 0.88125 0.88125C1.46875 0.29375 2.175 0 3 0H21C21.825 0 22.5312 0.29375 23.1188 0.88125C23.7063 1.46875 24 2.175 24 3V9.75L30 3.75V20.25L24 14.25V21C24 21.825 23.7063 22.5312 23.1188 23.1188C22.5312 23.7063 21.825 24 21 24H3ZM3 21H21V3H3V21Z"
                        fill="#46474C"
                      />
                    </svg>
                    <span>Use your camera</span>
                  </label>

                  <div className={styles.actions}>
                    <button className={styles.primary}>Allow this time</button>
                    <button className={styles.primary}>
                      Allow on every visit
                    </button>
                    <button className={styles.primary}>Don&apos;t Allow</button>
                  </div>
                </div>
              </Modal.Body>
            </Modal>
          </div>
          {/* PhotoCaptureFlow */}
          {/* mobileStep === "permissionDenied" */}
          <div className="d-none w-100 ">
            <div className={styles.wrapper_denied_camera_access}>
              <div className="container">
                <div className="row align-items-center h-100">
                  <div className="col-md-7">
                    <div className="ps-xl-5 ms-xl-5 pe-xl-5">
                      <div className={styles.illustration}>
                        <Image
                          src={cemeraNeeded}
                          alt="Camera Access"
                          width={508}
                          height={745}
                        />
                      </div>
                    </div>
                  </div>

                  <div className="col-md-5">
                    <div className={styles.content}>
                      <h3>Camera Access Needed</h3>
                      <p className="mb-md-5 ">
                        Oops! We need your camera access to bring this
                        experience to life.
                      </p>

                      <div>
                        <button className={styles.ctaBtnp}>
                          Restart Experience
                          <svg
                            className="ms-1"
                            width="20"
                            height="20"
                            viewBox="0 0 30 30"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M5.19386 3.64893C7.82334 1.37532 11.251 0 15 0C23.2842 0 30 6.71572 30 15C30 18.2041 28.9953 21.1737 27.2838 23.6109L22.5 15H27C27 8.37258 21.6275 3 15 3C11.7747 3 8.84665 4.2724 6.69034 6.34263L5.19386 3.64893ZM24.8061 26.3511C22.1766 28.6246 18.749 30 15 30C6.71572 30 0 23.2842 0 15C0 11.7958 1.00469 8.82624 2.7162 6.38916L7.5 15H3C3 21.6275 8.37258 27 15 27C18.2253 27 21.1533 25.7276 23.3097 23.6574L24.8061 26.3511Z"
                              fill="white"
                            />
                          </svg>
                        </button>
                        <br />
                        <button className={styles.link}>
                          Close Window{" "}
                          <svg
                            width="20"
                            height="20"
                            viewBox="0 0 36 36"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M27 9L9 27"
                              stroke="#262121"
                              strokeWidth="3"
                              strokeLinecap="round"
                              strokeLinejoin="round"
                            />
                            <path
                              d="M9 9L27 27"
                              stroke="#262121"
                              strokeWidth="3"
                              strokeLinecap="round"
                              strokeLinejoin="round"
                            />
                          </svg>
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          {/* PhotoCaptureFlow */}
          {/* mobileStep === "faceResult" */}
          <div className="d-none w-100">
            <div className={styles.reupload_view_shap_welcome}>
              <div className={styles.bgImage}>
                <Image src={FaceUpload} alt="Welcome Screen" />
              </div>
              <div className={styles.shapeOfYou}>
                <div className={styles.content_bg}>
                  {/* <div className={styles.contant_text}></div> */}
                </div>
                <div className={styles.button_cont}>
                  <button className={styles.ctaBtn1}>
                    Reupload Image{" "}
                    <svg
                      width="20"
                      height="20"
                      viewBox="0 0 36 36"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M22.5 12H22.5146"
                        stroke="#262121"
                        strokeWidth="3"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                      <path
                        d="M18.75 31.5H9C7.80653 31.5 6.66193 31.0259 5.81802 30.182C4.97411 29.3381 4.5 28.1935 4.5 27V9C4.5 7.80653 4.97411 6.66193 5.81802 5.81802C6.66193 4.97411 7.80653 4.5 9 4.5H27C28.1935 4.5 29.3381 4.97411 30.182 5.81802C31.0259 6.66193 31.5 7.80653 31.5 9V18.75"
                        stroke="#262121"
                        strokeWidth="3"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                      <path
                        d="M4.5 24L12 16.5C13.392 15.1605 15.108 15.1605 16.5 16.5L21.75 21.75"
                        stroke="#262121"
                        strokeWidth="3"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                      <path
                        d="M21 21.0001L22.5 19.5001C23.5185 18.5206 24.7095 18.2566 25.821 18.7111"
                        stroke="#262121"
                        strokeWidth="3"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                      <path
                        d="M28.5 33V24"
                        stroke="#262121"
                        strokeWidth="3"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                      <path
                        d="M33 28.5L28.5 24L24 28.5"
                        stroke="#262121"
                        strokeWidth="3"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                    </svg>
                  </button>
                  <button className={styles.ctaBtn}>
                    Explore Jewellery{" "}
                    <svg
                      width="20"
                      height="20"
                      viewBox="0 0 36 36"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M2.99972 19.5002L2.99951 16.5003H27.2574L21.3328 10.5757L23.4541 8.45435L33.0001 18.0003L23.4541 27.5463L21.3328 25.4248L27.2575 19.5003L2.99972 19.5002Z"
                        fill="white"
                      />
                    </svg>
                  </button>
                </div>
              </div>
            </div>
          </div>
          {/* PhotoCaptureFlow */}
          {/* mobileStep === "faceScanning" */}
          <div className="d-none w-100">
            <div className={styles.scan_face_desktop}>
              <div className={styles.bgImage}>
                <Image src={decktoFace} alt="Welcome Screen" />
              </div>
              <div className={styles.shapeOfYou}>
                <div className={styles.button_cont}>
                  <button className={styles.ctaBtn}>
                    Scan Face{" "}
                    <svg
                      width="20"
                      height="20"
                      viewBox="0 0 36 36"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M10.5 4.5H7.5C5.84314 4.5 4.5 5.84314 4.5 7.5V10.5"
                        stroke="white"
                        strokeWidth="3"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                      <path
                        d="M25.5 4.5H28.5C30.1569 4.5 31.5 5.84314 31.5 7.5V10.5"
                        stroke="white"
                        strokeWidth="3"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                      <path
                        d="M22.5 13.5V16.5"
                        stroke="white"
                        strokeWidth="3"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                      <path
                        d="M13.5 13.5V16.5"
                        stroke="white"
                        strokeWidth="3"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                      <path
                        d="M13.5 22.5C13.5 22.5 15 24 18 24C21 24 22.5 22.5 22.5 22.5"
                        stroke="white"
                        strokeWidth="3"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                      <path
                        d="M10.5 31.5H7.5C5.84314 31.5 4.5 30.1569 4.5 28.5V25.5"
                        stroke="white"
                        strokeWidth="3"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                      <path
                        d="M25.5 31.5H28.5C30.1569 31.5 31.5 30.1569 31.5 28.5V25.5"
                        stroke="white"
                        strokeWidth="3"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                    </svg>
                  </button>
                </div>
              </div>
            </div>
          </div>
          {/* AuthenticationFlow */}
          {/* mobileStep === "login" */}
          <div className="d-none w-100">
            <div className={styles.Login_face_desktop}>
              <div className={styles.bgImage}>
                <Image src={WelcomeScreenImg} alt="Welcome Screen" />
              </div>
              <div className={styles.shapeOfYou}>
                <div className="container">
                  <div className="row">
                    <div className="col-md-7">
                      <div className={styles.content}>
                        <div className={styles.title}>
                          <Image src={SOYLockUp} alt="Shape of You Logo" />
                        </div>
                      </div>
                    </div>
                    <div className="col-md-5">
                      <div className={styles.Login_container_form}>
                        <div className={styles.card}>
                          <h1 className={styles.title_m}>Login</h1>
                          <p className={styles.subtitle}>
                            Enter your phone number
                          </p>

                          <div className={styles.inputBox}>
                            <svg
                              className={styles.icon}
                              width="20"
                              height="20"
                              viewBox="0 0 36 36"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                d="M7.5 6H13.5L16.5 13.5L12.75 15.75C14.3564 19.0073 16.9927 21.6436 20.25 23.25L22.5 19.5L30 22.5V28.5C30 29.2956 29.6839 30.0587 29.1213 30.6213C28.5587 31.1839 27.7956 31.5 27 31.5C21.1489 31.1444 15.6302 28.6597 11.4852 24.5148C7.34026 20.3698 4.85557 14.8511 4.5 9C4.5 8.20435 4.81607 7.44129 5.37868 6.87868C5.94129 6.31607 6.70435 6 7.5 6Z"
                                stroke="#262121"
                                strokeWidth="3"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                              />
                            </svg>

                            {/* <span className={styles.code}>+91</span>
                        <div className={styles.divider}></div> */}
                            <input
                              type="text"
                              placeholder=" Phone number"
                              className={styles.input}
                            />
                          </div>

                          <button className={styles.button}>
                            Proceed{" "}
                            <svg
                              width="25"
                              height="17"
                              viewBox="0 0 30 20"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                d="M0.000209928 11.0458L0 8.04596H24.2579L18.3333 2.12131L20.4546 0L30.0006 9.54596L20.4546 19.092L18.3333 16.9705L24.258 11.046L0.000209928 11.0458Z"
                                fill="white"
                              />
                            </svg>
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          {/* AuthenticationFlow */}
          {/* mobileStep === "signup" */}
          <div className="d-none w-100">
            <div className={styles.signup_face_desktop}>
              <div className={styles.bgImage}>
                <Image src={WelcomeScreenImg} alt="Welcome Screen" />
              </div>
              <div className={styles.shapeOfYou}>
                <div className="container">
                  <div className="row">
                    <div className="col-md-7">
                      <div className={styles.content}>
                        <div className={styles.title}>
                          <Image src={SOYLockUp} alt="Shape of You Logo" />
                        </div>
                      </div>
                    </div>
                    <div className="col-md-5">
                      <div className={styles.Login_container_form}>
                        <div className={styles.card}>
                          <h1 className={styles.title_m}>Enter Your Details</h1>
                          <p className={styles.subtitle}>
                            Let us get to know you better
                          </p>

                          <div className={styles.inputBox}>
                            <svg
                              className={styles.icon}
                              width="20"
                              height="20"
                              viewBox="0 0 36 36"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                d="M12 10.5C12 12.0913 12.6321 13.6174 13.7574 14.7426C14.8826 15.8679 16.4087 16.5 18 16.5C19.5913 16.5 21.1174 15.8679 22.2426 14.7426C23.3679 13.6174 24 12.0913 24 10.5C24 8.9087 23.3679 7.38258 22.2426 6.25736C21.1174 5.13214 19.5913 4.5 18 4.5C16.4087 4.5 14.8826 5.13214 13.7574 6.25736C12.6321 7.38258 12 8.9087 12 10.5Z"
                                stroke="#262121"
                                strokeWidth="3"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                              />
                              <path
                                d="M9 31.5V28.5C9 26.9087 9.63214 25.3826 10.7574 24.2574C11.8826 23.1321 13.4087 22.5 15 22.5H21C22.5913 22.5 24.1174 23.1321 25.2426 24.2574C26.3679 25.3826 27 26.9087 27 28.5V31.5"
                                stroke="#262121"
                                strokeWidth="3"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                              />
                            </svg>

                            {/* <span className={styles.code}>+91</span>
                        <div className={styles.divider}></div> */}
                            <input
                              type="text"
                              placeholder=" Full Name"
                              className={styles.input}
                            />
                          </div>
                          <div className={styles.inputBox}>
                            <svg
                              className={styles.icon}
                              width="20"
                              height="20"
                              viewBox="0 0 36 36"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                d="M7.5 6H13.5L16.5 13.5L12.75 15.75C14.3564 19.0073 16.9927 21.6436 20.25 23.25L22.5 19.5L30 22.5V28.5C30 29.2956 29.6839 30.0587 29.1213 30.6213C28.5587 31.1839 27.7956 31.5 27 31.5C21.1489 31.1444 15.6302 28.6597 11.4852 24.5148C7.34026 20.3698 4.85557 14.8511 4.5 9C4.5 8.20435 4.81607 7.44129 5.37868 6.87868C5.94129 6.31607 6.70435 6 7.5 6Z"
                                stroke="#262121"
                                strokeWidth="3"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                              />
                            </svg>

                            {/* <span className={styles.code}>+91</span>
                        <div className={styles.divider}></div> */}
                            <input
                              type="text"
                              placeholder=" Phone number"
                              className={styles.input}
                            />
                          </div>
                          <div className={styles.inputBox}>
                            <svg
                              className={styles.icon}
                              width="20"
                              height="20"
                              viewBox="0 0 36 36"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                d="M4.5 10.5C4.5 9.70435 4.81607 8.94129 5.37868 8.37868C5.94129 7.81607 6.70435 7.5 7.5 7.5H28.5C29.2956 7.5 30.0587 7.81607 30.6213 8.37868C31.1839 8.94129 31.5 9.70435 31.5 10.5V25.5C31.5 26.2956 31.1839 27.0587 30.6213 27.6213C30.0587 28.1839 29.2956 28.5 28.5 28.5H7.5C6.70435 28.5 5.94129 28.1839 5.37868 27.6213C4.81607 27.0587 4.5 26.2956 4.5 25.5V10.5Z"
                                stroke="#262121"
                                strokeWidth="3"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                              />
                              <path
                                d="M4.5 10.5L18 19.5L31.5 10.5"
                                stroke="#262121"
                                strokeWidth="3"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                              />
                            </svg>

                            {/* <span className={styles.code}>+91</span>
                        <div className={styles.divider}></div> */}
                            <input
                              type="email"
                              placeholder=" Email Id"
                              className={styles.input}
                            />
                          </div>
                          <div className={styles.inputBox}>
                            <svg
                              className={styles.icon}
                              width="20"
                              height="20"
                              viewBox="0 0 32 32"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                d="M12 16C12 17.0609 12.4214 18.0783 13.1716 18.8284C13.9217 19.5786 14.9391 20 16 20C17.0609 20 18.0783 19.5786 18.8284 18.8284C19.5786 18.0783 20 17.0609 20 16C20 14.9391 19.5786 13.9217 18.8284 13.1716C18.0783 12.4214 17.0609 12 16 12C14.9391 12 13.9217 12.4214 13.1716 13.1716C12.4214 13.9217 12 14.9391 12 16Z"
                                stroke="#262121"
                                strokeWidth="2.66667"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                              />
                              <path
                                d="M5.3335 16.0002C5.3335 18.8291 6.4573 21.5422 8.45769 23.5426C10.4581 25.543 13.1712 26.6668 16.0002 26.6668C18.8291 26.6668 21.5422 25.543 23.5426 23.5426C25.543 21.5422 26.6668 18.8291 26.6668 16.0002C26.6668 13.1712 25.543 10.4581 23.5426 8.45769C21.5422 6.4573 18.8291 5.3335 16.0002 5.3335C13.1712 5.3335 10.4581 6.4573 8.45769 8.45769C6.4573 10.4581 5.3335 13.1712 5.3335 16.0002Z"
                                stroke="#262121"
                                strokeWidth="2.66667"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                              />
                              <path
                                d="M16 2.6665V5.33317"
                                stroke="#262121"
                                strokeWidth="2.66667"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                              />
                              <path
                                d="M16 26.6665V29.3332"
                                stroke="#262121"
                                strokeWidth="2.66667"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                              />
                              <path
                                d="M26.6665 16H29.3332"
                                stroke="#262121"
                                strokeWidth="2.66667"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                              />
                              <path
                                d="M2.6665 16H5.33317"
                                stroke="#262121"
                                strokeWidth="2.66667"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                              />
                            </svg>

                            {/* <span className={styles.code}>+91</span>
                        <div className={styles.divider}></div> */}
                            <input
                              type="number"
                              placeholder=" Pincode"
                              className={styles.input}
                            />
                          </div>
                          <button className={styles.button}>
                            Proceed{" "}
                            <svg
                              width="25"
                              height="17"
                              viewBox="0 0 30 20"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                d="M0.000209928 11.0458L0 8.04596H24.2579L18.3333 2.12131L20.4546 0L30.0006 9.54596L20.4546 19.092L18.3333 16.9705L24.258 11.046L0.000209928 11.0458Z"
                                fill="white"
                              />
                            </svg>
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          {/* AuthenticationFlow */}
          {/* mobileStep === "verifyOtp" */}
          <div className="d-none w-100">
            <div className={styles.otp_face_desktop}>
              <div className={styles.bgImage}>
                <Image src={WelcomeScreenImg} alt="Welcome Screen" />
              </div>
              <div className={styles.shapeOfYou}>
                <div className="container">
                  <div className="row">
                    <div className="col-md-7">
                      <div className={styles.content}>
                        <div className={styles.title}>
                          <Image src={SOYLockUp} alt="Shape of You Logo" />
                        </div>
                      </div>
                    </div>
                    <div className="col-md-5">
                      <div className={styles.Login_container_form}>
                        <div className={styles.card}>
                          <h1 className={styles.title_m}>Verify OTP</h1>
                          <p className={styles.subtitle}>
                            OTP has been sent to your phone number
                          </p>

                          <div className={styles.otpContainer}>
                            <input
                              type="password"
                              maxLength={1}
                              className={styles.otpInput}
                            />

                            <input
                              type="password"
                              maxLength={1}
                              className={styles.otpInput}
                            />

                            <input
                              type="password"
                              maxLength={1}
                              className={styles.otpInput}
                            />

                            <input
                              type="password"
                              maxLength={1}
                              className={styles.otpInput}
                            />
                            <input
                              type="password"
                              maxLength={1}
                              className={styles.otpInput}
                            />

                            <input
                              type="password"
                              maxLength={1}
                              className={styles.otpInput}
                            />
                          </div>

                          <p className={styles.timer}>(OTP Timer)</p>

                          <div className={styles.resendRow}>
                            <span>Didn’t get an OTP?</span>
                            <button className={styles.resendBtn}>
                              Resend OTP
                            </button>
                          </div>

                          <div className={styles.editNumber}>
                            Edit Phone Number{" "}
                            <svg
                              width="20"
                              height="20"
                              viewBox="0 0 36 36"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                d="M24.6374 6.90763L26.1223 5.42265C27.3526 4.19245 29.3472 4.19245 30.5773 5.42265C31.8075 6.65286 31.8075 8.64739 30.5773 9.8776L29.0923 11.3626M24.6374 6.90763L14.6484 16.8966C13.8871 17.658 13.3471 18.6117 13.086 19.6561L12 24L16.3438 22.914C17.3883 22.653 18.342 22.1128 19.1034 21.3516L29.0923 11.3626M24.6374 6.90763L29.0923 11.3626"
                                stroke="#262121"
                                strokeWidth="3"
                                strokeLinejoin="round"
                              />
                              <path
                                d="M28.4999 20.25C28.4999 25.1812 28.4998 27.6468 27.138 29.3064C26.8887 29.6101 26.6102 29.8887 26.3063 30.138C24.6468 31.5 22.1811 31.5 17.2498 31.5H16.5C10.8431 31.5 8.01474 31.5 6.25738 29.7426C4.50004 27.9853 4.5 25.1568 4.5 19.5V18.75C4.5 13.8188 4.5 11.3532 5.86191 9.69366C6.11125 9.38985 6.38985 9.11125 6.69366 8.86191C8.35318 7.5 10.8188 7.5 15.75 7.5"
                                stroke="#262121"
                                strokeWidth="3"
                                strokeLinejoin="round"
                              />
                            </svg>
                          </div>

                          <button className={styles.submitBtn}>
                            Submit{" "}
                            <svg
                              width="20"
                              height="20"
                              viewBox="0 0 36 36"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                d="M2.99972 19.4999L2.99951 16.5001H27.2574L21.3328 10.5754L23.4541 8.4541L33.0001 18.0001L23.4541 27.5461L21.3328 25.4246L27.2575 19.5001L2.99972 19.4999Z"
                                fill="#858585"
                              />
                            </svg>
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          {/* ShareViewScreen */}
          {/* mobileStep === "shareView" */}
          <div className="d-none w-100">
            <div className={styles.SharePage_desktop}>
              <div className={styles.bgImage}>
                <Image src={SharePage} alt="Welcome Screen" />
              </div>
              <div className={styles.shapeOfYou}>
                <div className={styles.logo_left}>
                  <Image src={logoleft} alt="" />
                </div>
                <button className={styles.submitBtn}>
                  <svg
                    width="20"
                    height="18"
                    viewBox="0 0 20 18"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M11.0002 1V5C4.42519 6.028 1.98019 11.788 1.00019 17C0.963188 17.206 6.38419 11.038 11.0002 11V15L19.0002 8L11.0002 1Z"
                      stroke="white"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </svg>
                  Share
                </button>
              </div>
            </div>
          </div>
        </>
      )}
      {/* ========== END OLD DESKTOP VIEWS ========== */}

      {/* ========== NEW DESKTOP VIEWS ========== */}
      {/* Desktop Splash Screen */}

      {desktopStep === "splash" && (
        <DesktopSplashScreen navigateToStep={navigateToDesktopStep} />
      )}
      {/* Desktop Walkthrough Slider */}
      {desktopStep === "walkthrough" && (
        <DesktopWalkthroughScreen
          navigateToStep={navigateToDesktopStep}
          logStep={logShapeOfYouStep}
        />
      )}
      {/* Desktop About Screen */}
      {desktopStep === "about" && (
        <DesktopAboutScreen
          navigateToStep={navigateToDesktopStep}
          isAuthenticated={!!authState.user}
          logStep={logShapeOfYouStep}
        />
      )}
      {/* Desktop Terms & Conditions Screen */}
      {desktopStep === "tc" && (
        <DesktopTermsConditionsScreen
          navigateToStep={navigateToDesktopStep}
          isAuthenticated={!!authState.user}
          logStep={logShapeOfYouStep}
        />
      )}
      {/* Desktop Welcome/Start Experience Screen */}
      {desktopStep === "welcome" && (
        <DesktopWelcomeScreen navigateToStep={navigateToDesktopStep} />
      )}
      {/* Desktop Photo Capture Flow (Upload or Scan) */}
      {(desktopStep === "uploadOrScan" ||
        desktopStep === "cameraPermission" ||
        desktopStep === "faceScanning" ||
        desktopStep === "permissionDenied" ||
        desktopStep === "imageNotPermitted" ||
        desktopStep === "faceResult") && (
        <DesktopPhotoCaptureFlow
          initialStep={desktopStep as DesktopPhotoCaptureStep}
          isAuthenticated={!!authState.user}
          logStep={logShapeOfYouStep}
          onComplete={(data) => {
            // User completed the flow successfully
            console.log("Photo capture completed:", data);
            // Navigate based on authentication status
            if (authState.user) {
              setDesktopStep("productView");
            } else {
              setDesktopStep("login");
            }
          }}
          onExit={() => {
            // User exited the flow
            setDesktopStep("splash");
          }}
        />
      )}
      {/* Desktop Authentication Flow (Login, Signup, Verify OTP) */}
      {(desktopStep === "login" ||
        desktopStep === "signup" ||
        desktopStep === "verifyOtp") &&
        !authState.user && (
          <DesktopAuthenticationFlow
            initialStep={desktopStep as DesktopAuthStep}
            logStep={logShapeOfYouStep}
            onComplete={() => {
              // User completed authentication successfully
              setDesktopStep("productView");
            }}
            onExit={() => {
              // User exited authentication flow
              setDesktopStep("splash");
            }}
          />
        )}
      {/* Desktop Filter Screen */}
      {desktopStep === "filterView" && (
        <DesktopFilterViewScreen
          navigateToStep={navigateToDesktopStep}
          filter={mobileFilter}
          setFilter={setMobileFilter}
          activeTab={activeTab}
        />
      )}
      {/* Desktop Product View Screen */}
      {desktopStep === "productView" && (
        <DesktopProductViewScreen
          navigateToStep={navigateToDesktopStep}
          filter={mobileFilter}
          setFilter={setMobileFilter}
          activeTab={activeTab}
          setActiveTab={setActiveTab}
          selected={selected}
          setSelected={setSelected}
          logStep={logShapeOfYouStep}
        />
      )}
      {/* Desktop Share Screen */}
      {desktopStep === "shareView" && (
        <DesktopShareViewScreen
          navigateToStep={navigateToDesktopStep}
          virtualTryOnImage={shapeOfYouState.virtualTryOnImage}
          capturedImage={shapeOfYouState.capturedImage}
        />
      )}

      {/* ========== END NEW DESKTOP VIEWS ========== */}

      {/* Mobile Splash Screen */}
      {mobileStep === "splash" && (
        <SplashScreen navigateToStep={navigateToStep} />
      )}
      {/* Mobile Walkthrough Slider */}
      {mobileStep === "walkthrough" && (
        <WalkthroughScreen
          navigateToStep={navigateToStep}
          isAuthenticated={!!authState.user}
        />
      )}
      {/* Mobile About Screen */}
      {mobileStep === "about" && (
        <AboutScreen
          navigateToStep={navigateToStep}
          isAuthenticated={!!authState.user}
        />
      )}
      {/* Mobile Terms & Conditions Screen */}
      {mobileStep === "tc" && (
        <TermsConditionsScreen
          navigateToStep={navigateToStep}
          isAuthenticated={!!authState.user}
          logStep={logShapeOfYouStep}
        />
      )}
      {/* Mobile Welcome/Start Experience Screen */}
      {mobileStep === "welcome" && (
        <WelcomeScreen navigateToStep={navigateToStep} />
      )}
      {/* Mobile Photo Capture Flow (Upload or Scan) */}
      {(mobileStep === "uploadOrScan" ||
        mobileStep === "galleryPermission" ||
        mobileStep === "cameraPermission" ||
        mobileStep === "faceScanning" ||
        mobileStep === "permissionDenied" ||
        mobileStep === "faceResult") && (
        <PhotoCaptureFlow
          initialStep={mobileStep as PhotoCaptureStep}
          isAuthenticated={!!authState.user}
          logStep={logShapeOfYouStep}
          onComplete={(data) => {
            // User completed the flow successfully
            console.log("Photo capture completed:", data);
            // Navigate based on authentication status
            if (authState.user) {
              setMobileStep("productView");
            } else {
              setMobileStep("login");
            }
          }}
          onExit={() => {
            // User exited the flow
            setMobileStep("splash");
          }}
        />
      )}
      {/* Mobile Authentication Flow (Login, Signup, Verify OTP) */}
      {(mobileStep === "login" ||
        mobileStep === "signup" ||
        mobileStep === "verifyOtp") &&
        !authState.user && (
          <AuthenticationFlow
            initialStep={mobileStep as AuthStep}
            logStep={logShapeOfYouStep}
            onComplete={() => {
              // User completed authentication successfully
              setMobileStep("productView");
            }}
            onExit={() => {
              // User exited authentication flow
              setMobileStep("splash");
            }}
          />
        )}
      {/* Mobile Filter Screen */}
      {mobileStep === "filterView" && (
        <FilterViewScreen
          navigateToStep={navigateToStep}
          filter={mobileFilter}
          setFilter={setMobileFilter}
          activeTab={activeTab}
        />
      )}
      {mobileStep === "productView" && (
        <ProductViewScreen
          navigateToStep={navigateToStep}
          filter={mobileFilter}
          setFilter={setMobileFilter}
          activeTab={activeTab}
          setActiveTab={setActiveTab}
          selected={selected}
          setSelected={setSelected}
          logStep={logShapeOfYouStep}
        />
      )}
      {mobileStep === "shareView" &&
        (() => {
          console.log(
            "Parent - Redux virtualTryOnImage:",
            shapeOfYouState.virtualTryOnImage ? "exists" : "null"
          );
          console.log(
            "Parent - Redux capturedImage:",
            shapeOfYouState.capturedImage ? "exists" : "null"
          );
          return (
            <ShareViewScreen
              navigateToStep={navigateToStep}
              virtualTryOnImage={shapeOfYouState.virtualTryOnImage}
              capturedImage={shapeOfYouState.capturedImage}
            />
          );
        })()}
    </>
  );
};

export default ShapOfYou;
